import { jwtDecode } from "jwt-decode";
import { DecodedAccessToken } from "../store";

export const decodeJwt = (token: string): DecodedAccessToken => {
  return jwtDecode<DecodedAccessToken>(token);
};
